export enum ModulesEnum {
  ProjectMain,
  AnalysisDashboard,
  ProjectValuation,
  Comparables,
  ReportDesigner,
  AppSettings,
  Dataverse,
  Raci,
  UserDashboard
}

export enum ProjectValuationTabs {
  Projects,
  ValPortofolios,
  Dashboards,
  Properties,
  Tenant,
  Valuations
}

export enum MainProjectTabs {
  Projects,
  ValPortofolios,
  RiskEChecklist,
  EmaeBusinessCase
}

export enum ComparablesTabs {
  Properties,
  Valuations,
  Leases
}

export enum AdminTabs {
  BusinessUnits,
  Users,
  RoleManagment,
  CurrenciesManagement,
  CalculationModel,
  CalculationModelEdit,
  CalculationModelRegister,
  CalculationModelNone,
  RaciTemplate,
  RaciTemplateNew,
  RaciTemplateEdit,
  RaciTemplateNone,
  LocalizationHost,
  LocalizationForm
}

export enum RaciTabs {
  Overview,
  UserDashboard
}

export enum ModulesSvgEnum {
  './assets/icons/RiskAndCompliance.svg',
  './assets/icons/ManagementOverview.svg',
  './assets/icons/Val_Portfolios_icon.svg',
  './assets/icons/Properties_icon.svg',
  './assets/icons/ReportDesigner.svg',
  './assets/icons/AdminConsole.svg',
  './assets/icons/cog.svg',
  './assets/icons/checkmark.svg',
  './assets/icons/users.svg'
}
